import ScrollTo from 'lib/utils/ScrollTo';

const scrollToAnchor = () => {
  const anchor = window.location.hash?.slice(1);
  if (anchor) {
    ScrollTo(anchor, -50);
  }
};

export { scrollToAnchor };
